import script from "./ViewComposables.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewComposables.vue?vue&type=script&setup=true&lang=js"

import "./ViewComposables.vue?vue&type=style&index=0&id=570b628e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-570b628e"]])

export default __exports__